import request, { longRunningService } from './request'

// 通用请求方法
export const http = {
  get(url, params) {
    // 为GET请求添加platform字段
    const requestParams = params ? { ...params, platform: 'web' } : { platform: 'web' }
    
    return request({
      url,
      method: 'get',
      params: requestParams
    })
  },

  post(url, data, config = {}) {
    // 为POST请求添加platform字段作为查询参数
    const requestParams = config.params ? { ...config.params, platform: 'web' } : { platform: 'web' }
    
    return request({
      url,
      method: 'post',
      data,
      params: requestParams,
      ...config
    })
  },

  put(url, data, config = {}) {
    // 为PUT请求添加platform字段作为查询参数
    const requestParams = config.params ? { ...config.params, platform: 'web' } : { platform: 'web' }
    
    return request({
      url,
      method: 'put',
      data,
      params: requestParams,
      ...config
    })
  },

  delete(url, data, config = {}) {
    // 为DELETE请求添加platform字段作为查询参数
    const requestParams = config.params ? { ...config.params, platform: 'web' } : { platform: 'web' }
    
    return request({
      url,
      method: 'delete',
      data,
      params: requestParams,
      ...config
    })
  },

  // 上传文件
  upload(url, file, onUploadProgress) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('platform', 'web')
    
    return request({
      url,
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      onUploadProgress
    })
  }
}

// 导出所有 API 方法
export default http

// 重新导出 longRunningService
export { longRunningService }

// 导出模块
export * from './modules/storage' 